// extracted by mini-css-extract-plugin
export var footer = "_hu-0";
export var inherit = "_hu-1";
export var input = "_hu-2";
export var modalContent = "_hu-3";
export var quillEditor = "_hu-4";
export var subtitle = "_hu-5";